import React, { Component } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import _ from 'lodash';
import {
  AlignedGrid, QuoteComparisonExpansionPanel, createLoanGridElements, createLoanGridLabel,
  createLoanGridElementsWithRenderer,
  createMoneyLoanGridElements,
  createPeriodLoanGridElements,
  RightAlignedDiv,
  QuoteComparisonExpansionSummary,QuoteComparisonExpansionPanelDetails
} from './QuoteComparisonGridElements';
import numberFormatter from 'utils/numberFormatter';
class LenderFee extends Component {
  state = {
    expanded:true
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }

  calculateLenderFee = () => {
    // Lender Fee is `Origination Fees` * `Loan Amount`
    return (loan,placeholder) => {      
      const oiginationFees = loan["closingCostsOriginationFeePercent"] || 0;
      const loanAmount = loan["loanAmount"] || 0;      
      const value =  oiginationFees * loanAmount;  

      return numberFormatter.formatMoney(value, 0);      
    }
  }

  renderRate = (property) => {
    return (loan) => {
      let value = loan[property];
      if(!value && value !== 0)
        return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>)
      return (<RightAlignedDiv>{numberFormatter.formatRate(loan[property], 2, '\u2014')}</RightAlignedDiv>)
    }
  }

  renderMoney = (property) => {
    return (loan) => {
      let value = loan[property];
      if(!value && value !== 0)
        return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>)
      return (<RightAlignedDiv>{numberFormatter.formatMoney(loan[property], 2, '\u2014')}</RightAlignedDiv>)
    }
  }

  calculateClosingCosts = () => {
    //Closing Cost is (`Origination Fees` + `Broker Fees`) * `Loan Amount`
    return (loan,placeholder) => {          
      const totalClosingCosts = _.get(loan, 'closingCostsTotalAmount', 0);
      return numberFormatter.formatMoney(totalClosingCosts, 0);      
    }
  }

  render() {
    const { loans, isCombined } = this.props;
    const { expanded } = this.state;
    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />} expanded={expanded}>
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("Lender Fee")}
            {expanded && createMoneyLoanGridElements(loans, 'closingCostsOriginationFeeAmount',isCombined)}            
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Broker Fees Amount")}
            {createMoneyLoanGridElements(loans, 'closingCostsBrokerFeeAmount',isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Other Fees")}
            {createMoneyLoanGridElements(loans, 'closingCostsOtherAmount',isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Total Closing Costs")}
            {createLoanGridElementsWithRenderer(loans, this.calculateClosingCosts(),'\u2014', isCombined)}
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default LenderFee;